import { getQuicktravelUrl, getSeaLinkBasename } from 'utils/helpers';

const basename = getSeaLinkBasename();
const quicktravelUrl = getQuicktravelUrl();
const { hideLogin, hideAccount } = window.ecom.craftConfig.features;
const visitorNavigation = [];

if (!hideAccount) {
  visitorNavigation.unshift({
    name: 'Manage my booking',
    path: `/${basename}/secure-payment`,
    iconClass: 'far fa-ticket-alt',
  });
}

if (!hideAccount && !hideLogin) {
  visitorNavigation.unshift({
    name: 'Log in',
    path: `/${basename}/account/login`,
    iconClass: 'far fa-user',
  });
}

const loggedInUserNavigation = [
  {
    name: 'My account',
    path: `/${basename}/account`,
    iconClass: 'far fa-user',
  },
  {
    name: 'Log out',
    path: `/${basename}/account/logout`,
    iconClass: 'far fa-sign-out',
  },
];

const vendorUserNavigation = [
  {
    name: 'My account',
    path: `/${basename}/account`,
    iconClass: 'far fa-user',
  },
  {
    name: 'Manage allotments',
    path: `${quicktravelUrl}/services/vendor_listing`,
    externalUrl: true,
    iconClass: 'far fa-clipboard-list',
  },
  {
    name: 'Log out',
    path: `/${basename}/account/logout`,
    iconClass: 'far fa-sign-out',
  },
];

export const getUserNavigationLinks = (isLoggedIn, vendorId) => {
  if (!isLoggedIn) {
    return visitorNavigation;
  }

  if (vendorId) {
    return vendorUserNavigation;
  }

  return loggedInUserNavigation;
};
